import { sendEvent } from "~/app/analytics/ga/ga";

export const trackAddToComparisonClick = (designation: string | string[], isAdded: boolean, location: string) => {
  sendEvent({
    event: "product_comparison_related",
    push_context: isAdded ? "product_added_to_comparison_list" : "product_removed_from_comparison_list",
    from_where_action_was_taken: location,
    products: Array.isArray(designation) ? designation : [designation],
  });
};

export const trackClearComparisonClick = (designations: string[]) => {
  sendEvent({
    event: "product_comparison_related",
    push_context: "product_list_deleted",
    from_where_action_was_taken: "Product Comparison Dialog",
    products: designations,
  });
};

export const trackProductComparisonDialogOpen = (designations: string[]) => {
  sendEvent({
    event: "product_comparison_related",
    push_context: "user_visited_comparison_list",
    products: designations,
    total_products: designations.length,
  });
};

export const trackPCDownload = (type: "PDF" | "XLSX", designations: string[]) => {
  sendEvent({
    event: "product_comparison_related",
    push_context: type === "PDF" ? "pdf_downloaded" : "excel_downloaded",
    products: designations,
  });
};
